import {toUiMsg$} from '@/ui';
import {depth$} from './depth';
import {Depth} from '@/types';

export interface UDepth {
  type: 'depth';
  data: Depth;
}

export function subscribeDepth() {
  depth$.subscribe((data) => toUiMsg$.next({type: 'depth', data}));
}
